<template>
  <div>

    <div class="row">
      <div class="col-6">
        <card card-body-classes="" no-footer-line>
          
          <h4 slot="header" class="title title-up">{{ (scope == 'edit') ? 'Update' : 'Create New' }} Circular</h4>

          <form>
            <div class="row">

              <div class="col-6">
                <fg-input
                  type="text"
                  name="batches"
                  label="Batches"
                  v-validate="modelValidations.batches"
                  :error="getError('batches')"
                  v-model="model.batches">
                  <n-button type="primary" round block @click.native="openModal('batches')">Select Batches {{ ( model.batches && model.batches.length > 0) ? `(${model.batches.length})` : '' }}</n-button>
                </fg-input>
                <!-- <fg-input
                    type="text"
                    name="batches"
                    label="Batches"
                    v-validate="modelValidations.batches"
                    :error="getError('batches')"
                    v-model="model.batches">
                    <el-select 
                      class="select-primary" 
                      placeholder="Select Batches" 
                      v-model="model.batches" 
                      format="M/d/yyyy"
                      value-format="M/d/yyyy"
                      clearable filterable multiple>
                        <el-option v-for="(option, index) in batches" class="select-primary" :value="option" :label="`${option}`" :key="index">
                        </el-option>
                    </el-select>
                </fg-input> -->
              </div>

              <div class="col-3">
                <fg-input
                    type="text"
                    required
                    name="isNotification"
                    label="Notification ?"
                    v-validate="modelValidations.isNotification"
                    :error="getError('isNotification')"
                    v-model="model.isNotification">
                    <n-switch v-model="model.isNotification" on-text="Yes" off-text="No"></n-switch>
                </fg-input>
              </div>

              <div class="col-3"></div>

              <div class="col-6">
                <fg-input
                    v-if="model.isNotification"
                    type="text"
                    required
                    name="topics"
                    label="Topic"
                    v-validate="modelValidations.topics"
                    :error="getError('topics')"
                    v-model="model.topics">
                    <el-select 
                      class="select-primary" 
                      placeholder="Select Topic" 
                      v-model="model.topics" 
                      value-key="register_no" 
                      clearable filterable multiple>
                        <el-option v-for="(option, index) in topics" class="select-primary" :value="option" :label="`${option}`" :key="index">
                        </el-option>
                    </el-select>
                </fg-input>
              </div>

              <div class="col-6">
                <fg-input
                  v-if="model.isNotification"
                  required
                  type="date"
                  name="sent_time"
                  label="Sent Time ?"
                  v-validate="modelValidations.sent_time"
                  :error="getError('sent_time')"
                  v-model="model.sent_time">
                  <el-date-picker 
                      v-model="model.sent_time" 
                      type="datetime" 
                      placeholder="Sent Time">
                  </el-date-picker>
                </fg-input>
              </div>

              <div class="col-12">
                <label>Cover Image</label>
                <el-upload
                    ref="imageUploader"
                    class="avatar-uploader"
                    name="image"
                    list-type="text"
                    accept="image/jpeg,image/png"
                    :data="{path: 'glimpses/notices/'}"
                    :action="uploadURL"
                    :headers="headers"
                    :show-file-list="true"
                    :on-success="handleAvatarSuccess"
                    :before-remove="handleRemove"
                    :before-upload="beforeAvatarUpload">
                    <div v-if="model.image_url" class="avatar" :style="`background-image: url(${model.image_url})`"></div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>

              <div class="col-12">
                <fg-input
                  type="text"
                  name="link"
                  label="Link"
                  v-model="model.link"
                  v-validate="modelValidations.link"
                  :error="getError('link')">
                </fg-input>
              </div>

              <div class="col-12 mt-4">
                <fg-input
                    required
                    type="textarea"
                    name="notice"
                    label="Circular Content"
                    :rows="15"
                    v-validate="modelValidations.notice"
                    :error="getError('notice')"
                    v-model="model.notice">
                </fg-input>
              </div>

              <div class="col-12 text-center">
                <n-button @click.native.prevent="resetForm" type="default">Reset</n-button>
                <n-button @click.native.prevent="addToList" type="primary">Add to List</n-button>
              </div>

            </div>
          </form>

        </card>
      </div>
      <div class="col-6">
        <card card-body-classes="" no-footer-line>
          <h4 slot="header" class="title title-up">Circulars Preview</h4>

          <div class="row">
            <div class="col-12 mb-2">
              <fg-input
                required
                type="date"
                name="date"
                label="Date"
                :error="getError('date')"
                v-model="date">
                <el-date-picker 
                    v-model="date" 
                    type="date" 
                    format="M/d/yyyy"
                    value-format="M/d/yyyy"
                    placeholder="date">
                </el-date-picker>
              </fg-input>
            </div>

            <div class="col-12 mb-1" v-for="(notice, index) in notices" :key="index">
              <NoticeCard 
                v-bind="notice"
                @card-click="selectNotice(notice)"
              ></NoticeCard>
            </div>

            <div class="col-12">
              <NoticeCard :notice="null" ></NoticeCard>
            </div>

            <div class="col-12 text-center">
              <n-button @click.native.prevent="validate()" type="primary">{{ (scope == 'edit') ? 'Update' : 'Create' }} Circulars</n-button>
            </div>

          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="modals.batches" headerClasses="justify-content-center" footerClasses="justify-content-center" type="large">
        <h4 slot="header" class="title title-up">Select Batches</h4>
        <div class="row">
            <div class="col-12">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="Batches"
                    v-model="model.batches"
                    :titles="['Available', 'Selected']"
                    :data="transfer_batches">
                </el-transfer> 
            </div>
        </div>
    </modal>

  </div>
</template>

<script>
  import { Card, Switch, NoticeCard, Modal } from 'src/components';
  import { Select, Option, Tag, Upload, Drawer, DatePicker, Transfer } from "element-ui";

  import { mapGetters } from 'vuex';

  export default {
    components: {
      Card,
      Modal,
      NoticeCard,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tag.name]: Tag,
      [Switch.name]: Switch,
      [Upload.name]: Upload,
      [Drawer.name]: Drawer,
      [DatePicker.name]: DatePicker,
      [Transfer.name]: Transfer
    },
    computed: {
      ...mapGetters({
          authTokens: 'getAuthTokens',
          topics: 'getTopics',
          batches: 'getBatches',
          notices: 'getNotices'
      }),
      scope(){
        return this.$route.path.includes('edit') ? 'edit' : 'add'
      },
      transfer_batches(){
        let batches = []
        if(this.batches)
            this.batches.forEach((batch, index) => {
                batches.push({
                    label: batch,
                    key: index
                });
            });
        return batches;
      },
      headers(){
          this.authTokens['content-type'] = 'multipart/form-data'
          let {token, refreshtoken} = this.authTokens
          return {token, refreshtoken};
      },
      uploadURL(){
          return `${process.env.VUE_APP_BASE_URL}/tukio/misc/upload`
      }
    },
    data() {
      return {
          drawer: false,
          // scope: 'add',
          item: 'featured',
          searchQuery: null,
          date: null,
          model: {
              notice: null,
              batches: [],
              topics: [],
              isNotification: false,
              sent_time: null,
              image_url: null, 
              link: null
          },
          modelValidations: {
              notice: {
                  required: true,
              },
              batches: {
                  required: false,
              },
              sent_time: {
                  required: true,
              }
          },
          modals: {
            batches: false,
          },
          filterMethod(query, item) {
              return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
      };
    },
    methods: {
      openModal(name){
        this.modals[name] = true
      },
      getError(fieldName) {
          return this.errors.first(fieldName);
      },
      addToList() {
          this.$validator.validateAll().then(isValid => {
              // this.$emit('on-submit', this.registerForm, isValid);

              if(isValid){

                // transform batches in notices
                  let batches = []
                  this.model.batches.forEach((batch, index) => {
                      batches.push(this.batches[batch])
                  })
                  this.model.batches = batches
                  
                 this.notices.push(Object.assign({},this.model));
                 this.model = {
                      notice: null,
                      batches: [],
                      topics: [],
                      isNotification: false,
                      sent_time: null,
                      image_url: null, 
                      link: null
                  }
                  this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
              }
          });
      },
      validate() {
          if(!this.date){
            this.$notify({
                message: `Choose a date for the circular to be created.`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'warning'
            })
            return ;
          }

          if(this.notices.length <= 0){
            this.$notify({
                message: `Atleast one circular is requied`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'warning'
            })
            return ;
          }
          

          let payload = {
            date: this.date,
            notices: this.notices
          }
          switch(this.scope){
              case 'add'  : this.$store.dispatch('createNotice', Object.assign({}, payload)); break;
              case 'edit' : this.$store.dispatch('updateNotice', Object.assign({}, payload)); break;
          }
      },
      selectNotice(notice){
        let batches = []
        notice.batches.forEach((batch, index) => {
          batches.push(this.batches.findIndex((item) => item == batch))
        })
        notice.batches = batches

        this.model = Object.assign({}, notice)
        this.removeNotice(notice)
      },
      resetForm(){
        this.model = {
              notice: null,
              batches: [],
              topics: [],
              isNotification: false,
              sent_time: null,
              image_url: null, 
              link: null
          }
      },
      removeNotice(notice){
        const index = this.notices.indexOf(notice);
        if (index > -1) {
          this.notices.splice(index, 1);
        }
      },
      handleRemove(file, fileList){
        this.model.image_url = null
      },
      handlePreview(file) {
        this.model.image_url = URL.createObjectURL(file.raw);
      },
      handleAvatarSuccess(res, file) {
          this.model.image_url = res.data.image;
      },
      beforeAvatarUpload(file) {
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isLt2M) {
              this.$notify({
                  message: `Cover picture size can not exceed 2MB!`,
                  icon: 'fa fa-bell',
                  horizontalAlign: 'right',
                  verticalAlign: 'top',
                  type: 'danger'
              })
          }
          return isLt2M;
      },
    },
    mounted() {
      this.$store.dispatch('getTopics');
      this.$store.dispatch('getBatches');
      if(this.scope == 'edit'){
        this.date = this.$route.params.date.split("-").join("/")
        this.$store.dispatch('getNoticeByDate', {date: this.date})
      }
    },
    watch: {
      // notices(val){
      //     val.forEach((notice) => {
      //       let batches = []
      //       notice.batches.forEach((batch, index) => {
      //           batches.push(this.batches.findIndex((item) => item == batch))
      //       })
      //       notice.batches = batches
      //     })
      // },
      // batches(batchesVal){
      //   if(this.notices.length > 0){
      //     this.notices.forEach((notice) => {
      //       let batches = []
      //       notice.batches.forEach((batch, index) => {
      //           batches.push(this.batches.findIndex((item) => item == batch))
      //       })
      //       notice.batches = batches
      //     })
      //   }
      // }
    }
  };
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-dialog__wrapper{
    position: fixed;
    height: 100vh;
    width: 50%;
    top: 0;
    right: 0px;
  }

  .news-drawer{
    .el-drawer__close-btn{
      outline: none;
    }

    .el-drawer__header{
      margin-bottom: 10px;
    }

    .el-drawer__body{
      padding: 5px 20px;

      label{
        display: none;
      }
    }

    .search-results{
      height: calc(100vh - 100px);
      overflow-y: auto;
    }
  }

  .form-group button{
    margin-top: 0;
  }

  .form-group textarea.form-control{
    max-height: 300px;
    resize: auto;
  }

</style>
